import { type AppDispatch } from "features/Application/globaltypes/redux";
import { type IOwnerItemModel } from "features/People/types";
import { DataService } from "../../../../Application/services/dataServices/typedDataService";
import { fetchBegin, fetchSuccess } from "../TemplateOwnersSlice";

export const fetchTemplateOwners = (templateId: number, queryParams: object) => async (dispatch: AppDispatch) => {
  dispatch(fetchBegin());
  try {
    const response = await DataService.groupTemplates.getTemplateOwners(templateId, queryParams);
    const data = {
      items: response.data.value.map((item) => ({ ...item }) as IOwnerItemModel),
      itemsCount: response.data["@odata.count"],
    };
    dispatch(fetchSuccess({ items: data.items, totalCount: data.itemsCount }));
  } catch (e) {}
};
